import { ISendFirstMessageV3Response } from '../../../repositories/chats/entities/chat/SendFirstMessageV3Response';
import { DEFAULT_ERROR_MESSAGE } from '../constants';
import { EFirstMessageResponseStatus, TFirstMessageResponse } from '../types';

export const map200Response = ({ chat, modalWarning }: ISendFirstMessageV3Response): TFirstMessageResponse => {
  if (chat && chat.chatId) {
    return {
      status: EFirstMessageResponseStatus.Success,
      data: chat,
    };
  }

  if (chat && chat.status === 'blocked') {
    return {
      status: EFirstMessageResponseStatus.Blocked,
    };
  }

  if (modalWarning) {
    return {
      status: EFirstMessageResponseStatus.ForbiddenText,
      data: modalWarning,
    };
  }

  return { status: EFirstMessageResponseStatus.UnknownError, data: { message: DEFAULT_ERROR_MESSAGE } };
};
